import { FOCUSABLE_ELEMENTS_STRING, KEYCODES } from '../constants';

const POPUP_DATA_ATTR = 'data-popup-id';

class ServiceMacPopup {
  onToggleClick = (e) => {
    e.preventDefault();

    this.openPopup();
  };

  onCloseClick = () => {
    this.closePopup();
  };

  onOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      this.closePopup();
    }
  };

  onDocumentKeydown = (e) => {
    if (
      this.isPopupExpanded() &&
      e.key === KEYCODES.ESC &&
      !document.querySelector(this.selectors.bootstrapModalBackdrop)
    ) {
      this.closePopup();
    }
  };

  onPopupTransitionend = (e) => {
    if (e.target === e.currentTarget && e.propertyName === 'opacity') {
      this.manageFocus();
    }
  };

  pageScroll = (state) => {
    if (state === 'lock') {
      document.documentElement.style.overflow = 'hidden';
    } else if (state === 'unlock')
      document.documentElement.style.overflow = 'visible';
  };

  constructor(toggler) {
    this.selectors = {
      closeBtn: '.js-close-popup-btn',
      bootstrapModalBackdrop: '.modal-backdrop.in',
    };

    this.classes = {
      open: 'is-open',
      focusClass: '.js-focus-me',
    };

    const popup = document.getElementById(
      toggler.getAttribute(POPUP_DATA_ATTR),
    );
    const closeBtn = popup.querySelector(this.selectors.closeBtn);
    const focusEl = document.querySelector(this.classes.focusClass);

    this.DOM = { toggler, popup, closeBtn, lastFocusOwner: null, focusEl };

    this.init();
  }

  init() {
    this.addListeners();
  }

  addListeners() {
    this.DOM.toggler.addEventListener('click', this.onToggleClick);
    this.DOM.closeBtn.addEventListener('click', this.onCloseClick);
    this.DOM.popup.addEventListener('click', this.onOverlayClick);
    this.DOM.popup.addEventListener('transitionend', this.onPopupTransitionend);
    document.addEventListener('keydown', this.onDocumentKeydown);
  }

  setPopupAttributes(state) {
    if (state === 'open') {
      this.DOM.popup.classList.add(this.classes.open);
      this.DOM.popup.setAttribute('aria-hidden', 'false');
    } else if (state === 'close') {
      this.DOM.popup.classList.remove(this.classes.open);
      this.DOM.popup.setAttribute('aria-hidden', 'true');
    }
  }

  setTogglerAttributes(state) {
    if (state === 'open') {
      this.DOM.toggler.setAttribute('aria-expanded', 'true');
      this.DOM.toggler.classList.add(this.classes.open);
    } else if (state === 'close') {
      this.DOM.toggler.setAttribute('aria-expanded', 'false');
      this.DOM.toggler.classList.remove(this.classes.open);
    }
  }

  openPopup() {
    this.setTogglerAttributes('open');
    this.setPopupAttributes('open');
    this.pageScroll('lock');
  }

  closePopup() {
    this.setTogglerAttributes('close');
    this.setPopupAttributes('close');
    this.pageScroll('unlock');
  }

  manageFocus() {
    if (this.isPopupExpanded()) {
      this.setLastFocusOwner();
      this.focusFirstInPopup();
    } else {
      this.DOM.lastFocusOwner.focus();
    }
  }

  setLastFocusOwner() {
    this.DOM.lastFocusOwner = document.activeElement;
  }

  focusFirstInPopup() {
    let focusables = FOCUSABLE_ELEMENTS_STRING;
    if (this.DOM.focusEl) {
      focusables = this.classes.focusClass;
    }
    const allFocusables = this.DOM.popup.querySelectorAll(focusables);

    if (allFocusables.length) {
      allFocusables[0].focus();
    }
  }

  isPopupExpanded() {
    return this.DOM.toggler.getAttribute('aria-expanded') === 'true';
  }
}

export default () => {
  const togglers = document.querySelectorAll(`[${POPUP_DATA_ATTR}]`);

  if (togglers.length) {
    togglers.forEach((toggler) => new ServiceMacPopup(toggler));
  }
};
